import React from 'react';
import { motion } from 'framer-motion';

export const LoadingScreen: React.FC = () => {
  return (
    <motion.div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#09090b]"
      initial={{ opacity: 1 }}
      exit={{ 
        opacity: 0,
        transition: { duration: 0.8, ease: "easeInOut" }
      }}
    >
      <div className="relative w-32 h-32 md:w-48 md:h-48">
        <svg 
          viewBox="0 0 728 880" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg" 
          className="w-full h-full"
        >
          {/* Path 1: Luna Esterna */}
          <motion.path 
            d="M618.412 263.871C651.891 313.121 671.454 372.592 671.454 436.629C671.454 606.562 533.696 744.325 363.762 744.325C193.829 744.325 56.07 606.563 56.07 436.629C56.07 266.696 193.828 128.937 363.762 128.937C441.595 128.937 512.683 157.841 566.87 205.495" 
            stroke="white" 
            strokeWidth="24"
            strokeLinecap="round"
            initial={{ pathLength: 0, opacity: 0 }}
            animate={{ pathLength: 1, opacity: 1 }}
            transition={{ 
              duration: 2, 
              ease: "easeInOut",
              delay: 0.2 
            }}
          />
          
          {/* Path 2: Pallino */}
          <motion.circle 
            cx="596.34" 
            cy="231.868" 
            r="25" 
            fill="white"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ 
              duration: 0.5, 
              ease: "backOut",
              delay: 1.8 
            }} 
          />
          
          {/* Path 3: Linea Verticale */}
          <motion.path 
            d="M363.763 822.932L363.763 56.069" 
            stroke="white" 
            strokeWidth="24"
            initial={{ pathLength: 0, opacity: 0 }}
            animate={{ pathLength: 1, opacity: 1 }}
            transition={{ 
              duration: 1.5, 
              ease: "easeInOut",
              delay: 0.5 
            }} 
          />
          
          {/* Path 4: Arco Interno */}
          <motion.path 
            d="M363.763 744.323C255.842 711.065 175.855 580.919 175.855 436.631C175.855 293.193 256.809 163.031 363.763 128.939" 
            stroke="white" 
            strokeWidth="24" 
            strokeLinecap="butt"
            initial={{ pathLength: 0, opacity: 0 }}
            animate={{ pathLength: 1, opacity: 1 }}
            transition={{ 
              duration: 1.8, 
              ease: "easeInOut",
              delay: 0.8 
            }}
          />
        </svg>
      </div>
    </motion.div>
  );
};